import { Center, Stack } from "@mantine/core";
import styles from "./navbar-item.module.scss";
import type { IProps } from "./navbar-item.types";
import { Text } from "../../../text";
import { Box } from "../../../box";
import { forwardRef } from "react";
import { Icon } from "../../../icon";

const NavbarItem = forwardRef<HTMLDivElement, IProps>(function NavbarItem(
    { icon, label, active, className, ...other },
    ref
) {
    return (
        <Box
            component="div"
            className={`${className} ${styles["container"]}`}
            data-active={active}
            ref={ref}
            {...other}
        >
            <Stack align="center" gap={2}>
                <Center className={styles["icon-container"]} data-active={active}>
                    <Icon size="md" icon={icon} />
                </Center>
                <Text ta="center" className={styles["label"]} variant="semibold" size="xxs" data-active={active}>
                    {label}
                </Text>
            </Stack>
        </Box>
    );
});

export { NavbarItem };
